(function () {
  var desktopQuery = window.matchMedia('(min-width: 990px)');
  var reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
  var stickyHeader = document.querySelector('.rsi-desktop-header');
  var searchInput = stickyHeader && stickyHeader.querySelector('[data-rsi-placeholder-examples]');
  var megaItems = stickyHeader ? Array.prototype.slice.call(stickyHeader.querySelectorAll('[data-rsi-mega-item]')) : [];
  var activeMegaItem = null;
  var megaCloseTimer = null;
  var stickyStart = 0;
  var rotateTimer = null;
  var placeholderIndex = 0;

  function isDesktop() {
    return desktopQuery.matches;
  }

  // Search must take priority over nav dropdowns. `overlay-predictive-search`
  // is toggled by the predictive-search custom element itself (assets/
  // predictive-search.js) whenever results are open, so this reads real
  // component state rather than tracking a second, parallel flag. Focus is
  // also treated as active so hovering into a dropdown the instant someone
  // clicks into (still-empty) search doesn't open a mega menu underneath it.
  function isSearchActive() {
    if (document.body.classList.contains('overlay-predictive-search')) return true;
    if (searchInput && document.activeElement === searchInput) return true;
    return false;
  }

  function calculateStickyStart() {
    if (!stickyHeader) return;
    stickyHeader.classList.remove('rsi-desktop-header--stuck');
    stickyStart = stickyHeader.getBoundingClientRect().top + window.pageYOffset;
    updateStickyState();
  }

  function updateStickyState() {
    if (!stickyHeader) return;

    if (!isDesktop()) {
      stickyHeader.classList.remove('rsi-desktop-header--stuck');
      closeAllMegaMenus();
      return;
    }

    var isStuck = window.pageYOffset > stickyStart;
    stickyHeader.classList.toggle('rsi-desktop-header--stuck', isStuck);

    if (isStuck) {
      closeAllMegaMenus();
    }
  }

  function getPlaceholderExamples() {
    if (!searchInput) return [];

    return (searchInput.getAttribute('data-rsi-placeholder-examples') || '')
      .split('|')
      .map(function (item) { return item.trim(); })
      .filter(Boolean);
  }

  function stopPlaceholderRotation() {
    if (rotateTimer) {
      window.clearInterval(rotateTimer);
      rotateTimer = null;
    }
  }

  function startPlaceholderRotation() {
    var examples = getPlaceholderExamples();

    stopPlaceholderRotation();

    if (!searchInput || !isDesktop() || reducedMotionQuery.matches || examples.length < 2 || searchInput.value) {
      return;
    }

    rotateTimer = window.setInterval(function () {
      if (document.activeElement === searchInput || searchInput.value) {
        stopPlaceholderRotation();
        return;
      }

      placeholderIndex = (placeholderIndex + 1) % examples.length;
      searchInput.setAttribute('placeholder', examples[placeholderIndex]);
    }, 3000);
  }

  function getMegaTrigger(item) {
    return item && item.querySelector('[data-rsi-mega-trigger]');
  }

  function getMegaMenu(item) {
    return item && item.querySelector('[data-rsi-mega-menu]');
  }

  function setMegaState(item, isOpen) {
    var trigger = getMegaTrigger(item);
    var menu = getMegaMenu(item);

    if (!trigger || !menu) return;

    item.classList.toggle('is-open', isOpen);
    trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    menu.hidden = !isOpen;
    menu.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
  }

  function closeMegaMenu(item) {
    if (!item) return;

    setMegaState(item, false);

    if (activeMegaItem === item) {
      activeMegaItem = null;
    }
  }

  function closeAllMegaMenus(exceptItem) {
    if (megaCloseTimer) {
      window.clearTimeout(megaCloseTimer);
      megaCloseTimer = null;
    }

    megaItems.forEach(function (item) {
      if (item !== exceptItem) {
        closeMegaMenu(item);
      }
    });
  }

  function openMegaMenu(item) {
    if (!item || !isDesktop()) return;

    if (isSearchActive()) {
      closeAllMegaMenus();
      return;
    }

    closeAllMegaMenus(item);
    activeMegaItem = item;
    setMegaState(item, true);
  }

  function scheduleMegaClose(item) {
    if (megaCloseTimer) {
      window.clearTimeout(megaCloseTimer);
    }

    megaCloseTimer = window.setTimeout(function () {
      if (!item.matches(':hover') && !item.contains(document.activeElement)) {
        closeMegaMenu(item);
      }
    }, 120);
  }

  function handleMegaMouseEnter(event) {
    openMegaMenu(event.currentTarget);
  }

  function handleMegaMouseLeave(event) {
    scheduleMegaClose(event.currentTarget);
  }

  function handleMegaFocusIn(event) {
    openMegaMenu(event.currentTarget);
  }

  function handleMegaFocusOut(event) {
    if (event.relatedTarget && event.currentTarget.contains(event.relatedTarget)) {
      return;
    }

    scheduleMegaClose(event.currentTarget);
  }

  function handleMegaKeydown(event) {
    if (event.key !== 'Escape') return;

    event.preventDefault();
    closeMegaMenu(event.currentTarget);

    var trigger = getMegaTrigger(event.currentTarget);
    if (trigger) {
      trigger.focus();
    }
  }

  function handleDesktopQueryChange() {
    calculateStickyStart();
    closeAllMegaMenus();
  }

  if (stickyHeader) {
    calculateStickyStart();
    window.addEventListener('scroll', updateStickyState, { passive: true });
    window.addEventListener('resize', calculateStickyStart);

    if (desktopQuery.addEventListener) {
      desktopQuery.addEventListener('change', handleDesktopQueryChange);
    } else if (desktopQuery.addListener) {
      desktopQuery.addListener(handleDesktopQueryChange);
    }
  }

  // 769-989px dead-zone fix, part 2 (CSS alone wasn't enough — see
  // assets/rsi-mobile-nav.css for part 1).
  //
  // assets/main.js's MainMenu treats theme.mediaMatches.md (the generic
  // theme's own ">= 769px" breakpoint) as "desktop" and, on load, force-sets
  // the native <details class="main-menu__disclosure"> element's `open`
  // attribute to true. The hamburger's own click handler
  // (MainMenu#handleMainMenuToggle) reads that same raw attribute — not the
  // ".is-open" class the CSS actually keys off — to decide whether a tap
  // should open or close the menu. Below RSI's real 990px swap-over, that
  // left the disclosure thinking it was already open, so the first tap in
  // the 769-989px range silently closed (no-opped) instead of opening.
  //
  // This corrects that attribute back via <main-menu>'s own existing
  // close() instance method (the same method MainMenu calls internally),
  // so it stays byte-for-byte consistent with how MainMenu closes itself —
  // no reimplementation of its open/close side effects here. assets/main.js
  // itself is never edited, so sections/header-install.liquid (which shares
  // the same <main-menu> engine via customElements.define('main-menu', ...)
  // but uses a plain ".header" wrapper, never ".rsi-desktop-header") is
  // completely unaffected.
  var mainMenuEl = stickyHeader && stickyHeader.querySelector('main-menu');
  var mobileDisclosure = mainMenuEl && mainMenuEl.querySelector('.main-menu__disclosure');

  function syncMobileDisclosure() {
    if (!mainMenuEl || !mobileDisclosure || isDesktop()) return;

    if (typeof mainMenuEl.close === 'function') {
      mainMenuEl.close(mobileDisclosure, false);
    } else {
      mobileDisclosure.open = false;
    }
  }

  if (mainMenuEl && mobileDisclosure) {
    syncMobileDisclosure();
    window.addEventListener('on:breakpoint-change', syncMobileDisclosure);

    if (desktopQuery.addEventListener) {
      desktopQuery.addEventListener('change', syncMobileDisclosure);
    } else if (desktopQuery.addListener) {
      desktopQuery.addListener(syncMobileDisclosure);
    }
  }

  megaItems.forEach(function (item) {
    item.addEventListener('mouseenter', handleMegaMouseEnter);
    item.addEventListener('mouseleave', handleMegaMouseLeave);
    item.addEventListener('focusin', handleMegaFocusIn);
    item.addEventListener('focusout', handleMegaFocusOut);
    item.addEventListener('keydown', handleMegaKeydown);
  });

  if (searchInput) {
    searchInput.addEventListener('focus', stopPlaceholderRotation);
    searchInput.addEventListener('focus', function () {
      closeAllMegaMenus();
    });
    searchInput.addEventListener('input', stopPlaceholderRotation);
    searchInput.addEventListener('blur', startPlaceholderRotation);
    startPlaceholderRotation();
  }

  // Typing can open the predictive-search results (adding
  // `overlay-predictive-search` to <body>) without a fresh focus event
  // firing, so a focus-only listener isn't enough to catch that moment.
  // Watching body's class directly closes any dropdown the instant search
  // actually becomes active, regardless of which path triggered it.
  if (window.MutationObserver) {
    var searchStateObserver = new MutationObserver(function () {
      if (isSearchActive()) {
        closeAllMegaMenus();
      }
    });
    searchStateObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });
  }
})();
